import React from 'react';

import MenuIcon from '@mui/icons-material/Menu';
import {
  Tooltip,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  ListSubheader,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import * as selectorsCommon from '../../Main/selector';

import { GenericIcon } from '@/components/GenericIcon';
import { postGroups } from '@/containers/const';
import { uiSlice } from '@/domain/ui/redux';

/** プロパティ */
export type Props = {
  /** 無効か */
  disabled: boolean,
}

const Menu: React.FC<Props> = ({ disabled }) => {
  const postsOrder = useSelector(selectorsCommon.postsSelector);
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = React.useState(false);
  const groups = postGroups.map((v) => {
    const items = postsOrder.filter((post) => post.category === v.key);
    if (items.length === 0) {
      return null;
    }
    return (
      <List
        key={v.key}
        sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
        subheader={<ListSubheader>{v.title}</ListSubheader>}
      >
        {items.map((post) => (
          <ListItem
            button
            key={post.key}
            onClick={() => {
              dispatch(uiSlice.actions.setPage(post.key));
              setIsOpen(false);
            }}
          >
            <ListItemIcon>
              <GenericIcon iconName={post.icon} />
            </ListItemIcon>
            <ListItemText primary={post.title} />
          </ListItem>
        ))}
      </List>
    );
  });
  return (
    <div>
      <Tooltip title="メニュー">
        <div>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="Menu"
            onClick={() => setIsOpen(true)}
            disabled={disabled}
          >
            <MenuIcon />
          </IconButton>
        </div>
      </Tooltip>
      <Drawer anchor="left" open={isOpen} onClose={() => setIsOpen(false)}>
        <div style={{ width: '250px' }}>
          <List>
            <ListItem
              button
              key="home"
              onClick={() => {
                dispatch(uiSlice.actions.setPage('home'));
                setIsOpen(false);
              }}
            >
              <ListItemIcon>
                <GenericIcon iconName="Home" />
              </ListItemIcon>
              <ListItemText primary="ホーム" />
            </ListItem>
          </List>
          {groups}
        </div>
      </Drawer>
    </div>
  );
};
export default Menu;
